module.exports = __webpack_public_path__ + "media/categories/9003-7b04d9ad.svg";